import { createPinia } from "pinia"
import piniaPersist from "pinia-plugin-persist"
import { createApp } from "vue"

import App from "@/App"
import router from "@/router"
import useThemeStore from "@/stores/theme"


// 表格插件
import VXETable from "vxe-table"
import "vxe-table/lib/style.css"

import Adaption from "@/utils/Adaption"
import "@/utils/animate"
// 路由判定
import "@/permission"

// echart
import "@/utils/echart"

// 字体图标
import "@/style/font/element/iconfont.css"
import "@/style/font/ali/iconfont.css"
import "@/style/font/project/font.css"

// tailwindcss
import "@/style/tailwind.scss"

// 自定义样式
import "@/style/main.scss"
import "@/style/login.scss"

// UI组件
import "@/style/element.scss"
import "element-plus/theme-chalk/dark/css-vars.css" // 引入暗黑主题变量
import "@/style/vxe.scss"

import "dayjs/locale/zh-cn"
import ElementPlus, { ElDialog } from "element-plus"

window.Adaption = new Adaption()
window.Adaption.init()

// pinia 持久化
const pinia = createPinia()
pinia.use(piniaPersist)

// 全局dialog可拖动
;(ElDialog as any).props.draggable.default = true

const app = createApp(App)

app.use(pinia).use(ElementPlus).use(VXETable).use(router)

// 路由准备完毕再挂载
router.isReady().then(() => app.mount("#app")).then(() => {
    // 初始化全局主题色
    const theme = useThemeStore()
    theme.initTheme()
})
